import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material';
import { Box } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';

export const NavUserWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSideBarOpen',
})<{ isSideBarOpen: boolean }>`
  cursor: pointer;
  bottom: 0;
  position: relative;
  padding-left: ${({ isSideBarOpen }) => (isSideBarOpen ? '1rem' : '0')};
  padding-bottom: 1rem;
  padding-right: 1rem;
  background-color: #1a1a2e;
  z-index: 2000;
`;

export const NavUserAvatar = styled(Avatar)`
  width: 2.125rem;
  height: 2.125rem;
  background: #60a5fa;
  color: #000;
  font-size: 0.75rem;
  font-weight: 600;
`;

export const NavUserNameTypography = styled(Typography)`
  font-size: 1rem;
  color: #fff;
  font-weight: 600;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
`;

export const NavUserRoleTypography = styled(Typography)`
  font-size: 0.875rem;
  color: #c4c4c4;
  font-weight: 400;
  line-height: 1.25rem;
`;

export const NavUserNameWrapper = styled('div')`
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  display: flex;
`;

export const NavUserWrapperContentAvatarWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSideBarOpen',
})<{ isSideBarOpen: boolean }>`
  display: flex;
  gap: 1rem;
  justify-content: ${({ isSideBarOpen }) => (isSideBarOpen ? 'flex-start' : 'center')};
  align-items: center;
  padding-left: ${({ isSideBarOpen }) => (isSideBarOpen ? '0.5rem' : '0')};
  padding-top: 1rem;
`;

export const NavUserWrapperContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isSideBarOpen',
})<{ isSideBarOpen: boolean }>`
  display: flex;
  flex-direction: column;
  margin-left: ${({ isSideBarOpen }) => (!isSideBarOpen ? '1rem' : '0')};
`;

export const UserCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSideBarOpen',
})<{ isSideBarOpen: boolean }>`
  display: ${({ isSideBarOpen }) => (isSideBarOpen ? 'block' : 'none')};
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 12px;
  margin: 8px 0;
  width: 100%;
`;

export const UserCardContent = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const UserInfoSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  padding: 2px;
`;

export const SettingsIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const VersionText = styled(Typography)`
  font-size: 0.875rem;
  color: #fff;
  font-weight: 400;
  text-align: center;
  margin-top: 8px;
  opacity: 0.8;
`;

export const CompactUserButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 8px 0;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:active {
    background: rgba(255, 255, 255, 0.15);
  }
`;

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    background: #2d3748;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    min-width: 240px;
    padding: 8px 0;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: 12px 16px;
  margin: 2px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    transform: translateX(2px);
  }

  &:active {
    background: rgba(255, 255, 255, 0.12);
  }
`;

export const MenuItemContent = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
`;

export const MenuItemIcon = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
  min-width: 24px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MenuItemText = styled(Box)`
  flex: 1;
  color: #e2e8f0;
`;

export const MenuDivider = styled(Divider)`
  margin: 8px 16px;
  border-color: rgba(255, 255, 255, 0.1);
`;
